// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

// Display names for shipping_carriers.carrier keys (D-SHIP-23: one map instead of a copy per page).

const NAMES: Record<string, string> = {
  roadpas: 'Roadpas (e-Courier)',
  roadpas_partner: 'RoadPas',
  fedex: 'FedEx',
  ups: 'UPS',
  usps: 'USPS',
  easypost: 'EasyPost',
  manual: 'Manual',
}

const PRINT_NAMES: Record<string, string> = { ...NAMES, roadpas: 'ROADPAS · e-Courier', roadpas_partner: 'ROADPAS' }

export const carrierLabel = (key: string): string => NAMES[key] ?? key

/** Uppercase-friendly variant for the printed label. */
export const carrierPrintLabel = (key: string): string => PRINT_NAMES[key] ?? key.toUpperCase()

// What each carrier kind needs to connect (D-SHIP-23 §10, the SaaS-admin Shipping tab).

export interface CarrierCredentialField { key: string; label: string; secret: boolean }

export interface CarrierSetup {
  credentials: CarrierCredentialField[]
  /** API root per environment; absent when the base URL is typed per account. */
  baseUrls?: { test: string; live: string }
  /** e-Courier site code. */
  usesSite: boolean
  /** account_number is a pickup location chosen from the carrier, not typed. */
  pickupFromCarrier: boolean
  accountLabel: string
  webhook: boolean
}

const SETUPS: Record<string, CarrierSetup> = {
  roadpas: {
    credentials: [{ key: 'username', label: 'Username', secret: false }, { key: 'password', label: 'Password', secret: true }],
    usesSite: true, pickupFromCarrier: false, accountLabel: 'Customer code', webhook: false,
  },
  roadpas_partner: {
    credentials: [{ key: 'api_key', label: 'API key', secret: true }, { key: 'webhook_secret', label: 'Webhook signing secret', secret: true }],
    baseUrls: { test: 'https://roadpas.click/api/partner/v1', live: 'https://app.roadpasdelivery.com/api/partner/v1' },
    usesSite: false, pickupFromCarrier: true, accountLabel: 'Default branch', webhook: true,
  },
  manual: { credentials: [], usesSite: false, pickupFromCarrier: false, accountLabel: 'Account number', webhook: false },
}

export const carrierSetup = (key: string): CarrierSetup => SETUPS[key] ?? SETUPS.manual
